export default __webpack_public_path__ + "static/media/9200_bp.907253cb.svg";